<template>
  <div
    :class="[progressBarClass]"
    class="progress-bar"
  >
    <div class="bar-background">
      <div
        :style="{ 'width': width, 'background-color': color }"
        class="progress-background"
      />
    </div>
    <span
      v-if="size !== 'xs'"
      class="progress-bar-text"
    >
      {{ text }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    progressionPercentage: {
      type: Number,
      required: true,
    },
    text: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: 'md',
    },
    color: {
      type: String,
      default: '#8992b2',
    },
  },
  computed: {
    width() {
      let progressionPercentage = this.progressionPercentage < 0 ? 0 : this.progressionPercentage;
      progressionPercentage = this.progressionPercentage > 100 ? 100 : this.progressionPercentage;

      return `calc(30px + ${progressionPercentage}%)`;
    },
    progressBarClass() {
      const allowedSizes = ['lg', 'md', 'sm', 'xs'];
      if (!allowedSizes.includes(this.size)) {
        return 'progress-bar-md';
      }

      return `progress-bar-${this.size}`;
    },
  },
};
</script>

<style scoped>
.progress-bar {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}

.bar-background {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 100px;
  background-color: #3b425c;
  overflow: hidden;
}

.progress-background {
  position: absolute;
  left: -30px;
  height: 100%;
  border-radius: 100px;
}

.progress-bar-text {
  position: absolute;
  left: 0;
  width: 100%;
  text-align: center;
  line-height: 30px;
}

.progress-bar-xs {
  width: 36px;
  height: 8px;
}

.progress-bar-sm {
  width: 150px;
  height: 15px;
}

.progress-bar-md {
  width: 220px;
  height: 22px;
}

.progress-bar-lg {
  width: 300px;
  height: 30px;
}

.progress-bar-sm .progress-bar-text{
  font-size: 10px;
}

.progress-bar-md .progress-bar-text{
  font-size: 15px;
}

.progress-bar-lg .progress-bar-text{
  font-size: 20px;
}
</style>
